module.exports = __webpack_public_path__ + "site/img/65.ce4955de.jpg";